import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { withIDKeys } from '@/utils/state_helpers'
import { snakeKeyed } from '@/utils/params_helpers'
import { del } from 'vue'
import store from '@/store'
import PaginationStorage from '@/utils/pagination_storage'

import { getDefaultPaginationState } from '@/store/shared/pagination'

export const useLocationsStore = defineStore('locations', {
  state: () => ({
    ...getDefaultPaginationState(),
    searchResults: {},
    showModal: false,
    searchQuery: '',
    newForm: false,
  }),

  getters: {
    noResults({ searchResults }) {
      return Object.keys(searchResults).length === 0
    }
  },

  actions: {
    async search({ page, perPage, newDefaultPerPage } = {}) {
      const { searchQuery } = this
      let pageStorage = new PaginationStorage({ page, perPage, newDefaultPerPage })
      pageStorage.save()

      return httpClient.get('/api/internal/locations', {
        params: {
          search: searchQuery,
          ...snakeKeyed(pageStorage.queryParams)
        }
      }).then(({ data: { locations, meta: { page }} }) => {
        this.searchResults = withIDKeys(locations)
        this.page = page
      })
    },

    async destroy({ id }) {
      return httpClient.delete(`/api/internal/locations/${id}`)
        .then(() => {
          del(this.searchResults, id)
          store.dispatch('messages/addNotice', 'Location deleted')
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    }
  }
})
